import { withInstall } from '@sgui-plus/utils/with-install'

import Image from './src/image.vue'

export const SgImage = withInstall(Image)
export default SgImage

export * from './src/image'
